module.exports = __webpack_public_path__ + "img/leodata_logo.a0355991.png";